<template>
  <div class="not-found">
    <vue-feather type="alert-circle" size="48" class="not-found-icon" />
    <h2>404</h2>
    <p class="not-found-message">{{ currentLanguage === 'TA' ? 'பக்கம் கிடைக்கவில்லை' : 'Page not found' }}</p>
    <p class="not-found-detail">{{ currentLanguage === 'TA' ? 'கோரப்பட்ட URL' : 'The requested URL' }} <b>{{ $route.path }}</b> {{ currentLanguage === 'TA' ? 'இந்த சேவையகத்தில் கிடைக்கவில்லை.' : 'was not found on this server.' }}</p>
    <router-link to="/" class="btn btn_primary not-found-home">
      <vue-feather type="home" size="16" />
      {{ currentLanguage === 'TA' ? 'முகப்புக்குச் செல்' : 'Go Home' }}
    </router-link>
  </div>
</template>

<script>
export default {
  inject: {
    languageRef: { from: 'currentLanguage', default: 'EN' }
  },
  computed: {
    currentLanguage() {
      return this.languageRef || 'EN';
    }
  }
}
</script>

<style scoped>
.not-found {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 80px 20px;
  text-align: center;
}

.not-found-icon {
  color: var(--text-muted);
  margin-bottom: 16px;
}

.not-found h2 {
  font-size: 48px;
  font-weight: 700;
  color: var(--text-secondary);
  margin: 0 0 8px 0;
}

.not-found-message {
  font-size: 20px;
  font-weight: 600;
  color: var(--text-secondary);
  margin: 0 0 12px 0;
}

.not-found-detail {
  font-size: 15px;
  color: var(--text-tertiary);
  margin: 0 0 24px 0;
  line-height: 1.5;
}

.not-found-home {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  text-decoration: none;
  font-size: 14px;
  font-weight: 600;
  padding: 10px 20px;
  border-radius: 20px;
  color: white;
  background-color: var(--accent-primary);
  transition: all 0.2s ease;
}

.not-found-home:hover {
  background-color: var(--accent-hover);
  transform: translateY(-1px);
}
</style>
